import React from "react";
import { ComingSoon } from "../../Components/ComingSoon/ComingSoon";

// TODO: Placeholder until the Cases API/data model is available.
export const CaseList: React.FC = () => (
  <ComingSoon title="Cases" breadCrumb="Case List" path="/case/list" message="Case management is coming soon." />
);
